import React from 'react'

import { FieldArray } from 'formik'

import LABEL from '../../../business-const/Label/Label'

import MESSAGE from '../../../business-const/Message/Message'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import AuthService from '../../../business-api/AuthService'

import {
    adicionaNaoInformar
} from '../../../business-components/Array/Array'

import { 
    IsXsDownScreen
} from '../../../business-components/Service/GlobalService'

import {
    ValidatorFormPadrao,
} from '../../../business-components/Form/Form'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem2,
    GridItem2xs6,
    GridItem3xs10,
    GridItem5xs12,
    GridItem8xs10,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import { 
    TextValidatorText,
} from '../../../business-components/TextValidator/TextValidator'

import { 
    TextFieldTextSelect,
    TextFieldNumberSelectDestaque,
} from '../../../business-components/TextField/TextFieldSelect'

import { 
    MuiPickersUtilsProviderPadrao,
    KeyboardDatePickerPadrao,
    KeyboardDateTimePickerPadrao,
} from '../../../business-components/MuiPickers/MuiPickers'

import {
    IconButtonClearEntradaDados
} from '../../../business-components/IconButton/IconButton'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import {
    equipeListCompartilhamento,
} from '../compartilhamento-form/CompartilhamentoService'



const Observacao = ({ values, item, ind, handleChange }) => {

    return (
        <TextValidatorText
            name={`funisEtapas[${ind}].observacao`}
            label={LABEL.observacao}
            value={item.observacao || ''}
            onChange={handleChange}
            tamMax={TAMMAX.observacao}
            disabled={values.ultimaVersao !== values.versao}
        />
    )
}



const AcompanhamentoFormFunisEtapas = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue, vars }) => {

    const isXsDownScreen = IsXsDownScreen()
   
    

    return (
        <ValidatorFormPadrao
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <GridContainer>
                <GridItem12>
                    <FieldArray name="funisEtapas">
                        {(arrayHelpers) => (
                            <CardGridEntradaDados>
                                <CardGridDivBodyEntradaDados>
                                    {vars.jsonConfiguracao &&
                                    vars.jsonConfiguracao.funis && 
                                    vars.jsonConfiguracao.funis.length > 0
                                        ?
                                            <DivForm
                                                className='mt-5 mb-5'
                                            >
                                                {values.funisEtapas?.map((item, ind) => {

                                                    const linhaEtapa = pesquisaList(vars.jsonConfiguracao.funilEtapas, item.etapa)

                                                    return (
                                                        <GridContainer
                                                            key={ind}
                                                        >
                                                            <GridItem12>
                                                                <GridContainer>
                                                                    <GridItem2xs6>
                                                                        {<MuiPickersUtilsProviderPadrao>
                                                                            <KeyboardDateTimePickerPadrao
                                                                                name={`funisEtapas[${ind}].dataHoraInclusao`}
                                                                                label={LABEL.dataHoraInclusao}
                                                                                value={item.dataHoraInclusao}
                                                                                onChange={(date) => {
                                                                                    setFieldValue(
                                                                                        `funisEtapas[${ind}].dataHoraInclusao`,
                                                                                        date,
                                                                                    )}
                                                                                }
                                                                                disabled={values.ultimaVersao !== values.versao || ind === 0}
                                                                            />
                                                                        </MuiPickersUtilsProviderPadrao>}
                                                                    </GridItem2xs6>

                                                                    <GridItem2xs6>
                                                                        <TextFieldNumberSelectDestaque
                                                                            name={`funisEtapas[${ind}].funil`}
                                                                            label={LABEL.funil}
                                                                            value={item.funil || ''}
                                                                            onChange={handleChange}
                                                                            list={
                                                                                vars.jsonConfiguracao.funis
                                                                                    .filter(funil => funil.id === item.funil || funil.ativo !== 'N')
                                                                            }
                                                                            disabled={values.ultimaVersao !== values.versao || ind === 0}
                                                                        />
                                                                    </GridItem2xs6>

                                                                    <GridItem2xs6>
                                                                        <TextFieldNumberSelectDestaque
                                                                            name={`funisEtapas[${ind}].etapa`}
                                                                            label={LABEL.etapa}
                                                                            value={item.etapa || ''}
                                                                            onChange={handleChange}
                                                                            list={
                                                                                vars.jsonConfiguracao.funilEtapas
                                                                                    .filter(funilEtapa => funilEtapa.funil === item.funil &&
                                                                                        (
                                                                                            funilEtapa.id === item.etapa ||
                                                                                            funilEtapa.ativo !== 'N'
                                                                                        ))
                                                                            }
                                                                            disabled={values.ultimaVersao !== values.versao || ind === 0}
                                                                        />
                                                                    </GridItem2xs6>
                                                                    
                                                                    <GridItem2xs6>
                                                                        {linhaEtapa.informarDataHoraPrevista && (
                                                                            <MuiPickersUtilsProviderPadrao>
                                                                                <KeyboardDateTimePickerPadrao
                                                                                    name={`funisEtapas[${ind}].dataHoraPrevistaFunilEtapa`}
                                                                                    label={LABEL.dataHoraPrevistaFunilEtapa}
                                                                                    value={item.dataHoraPrevistaFunilEtapa}
                                                                                    onChange={(date) => {
                                                                                        setFieldValue(
                                                                                            `funisEtapas[${ind}].dataHoraPrevistaFunilEtapa`,
                                                                                            date,
                                                                                        )}
                                                                                    }
                                                                                    disabled={values.ultimaVersao !== values.versao || ind === 0}
                                                                                />
                                                                            </MuiPickersUtilsProviderPadrao>
                                                                        )}
                                                                    </GridItem2xs6>

                                                                    <GridItem2xs6>
                                                                        {linhaEtapa.informarDataRealizacao && (
                                                                            <MuiPickersUtilsProviderPadrao>
                                                                                <KeyboardDatePickerPadrao
                                                                                    name={`funisEtapas[${ind}].dataRealizacaoFunilEtapa`}
                                                                                    label={LABEL.dataRealizacaoFunilEtapa}
                                                                                    value={item.dataRealizacaoFunilEtapa}
                                                                                    onChange={(date) => {
                                                                                        setFieldValue(
                                                                                            `funisEtapas[${ind}].dataRealizacaoFunilEtapa`,
                                                                                            date,
                                                                                        )}
                                                                                    }
                                                                                    disabled={values.ultimaVersao !== values.versao || ind === 0}
                                                                                />
                                                                            </MuiPickersUtilsProviderPadrao>
                                                                        )}
                                                                    </GridItem2xs6>
                                                                </GridContainer>

                                                                <GridContainer>
                                                                    {!isXsDownScreen && (
                                                                        <GridItem2/>
                                                                    )}

                                                                    {vars.jsonConfiguracao.habilitaCompartilhamentoClientes &&
                                                                    !AuthService.obterAcessoCliente(variaveisGlobais)/* && 
                                                                    vars.jsonConfiguracao.compartilhamentoPerfilUsuario*/
                                                                        ?
                                                                            <>
                                                                                <GridItem5xs12>
                                                                                    <Observacao
                                                                                        values={values}
                                                                                        item={item}
                                                                                        ind={ind}
                                                                                        handleChange={handleChange}
                                                                                    />
                                                                                </GridItem5xs12>
    
                                                                                <GridItem3xs10>
                                                                                    <TextFieldTextSelect
                                                                                        name={`funisEtapas[${ind}].idUsuarioDelegar`}
                                                                                        label={LABEL.delegar}
                                                                                        value={item.idUsuarioDelegar || ''}
                                                                                        onChange={handleChange}
                                                                                        list={
                                                                                            adicionaNaoInformar(
                                                                                                equipeListCompartilhamento(
                                                                                                    variaveisGlobais, values,
                                                                                                        item.idUsuarioDelegar,
                                                                                                            vars.perfil,
                                                                                                                vars.jsonConfiguracao,
                                                                                                                    vars.equipeList
                                                                                                )
                                                                                            )
                                                                                        }
                                                                                        disabled={values.ultimaVersao !== values.versao}
                                                                                    />
                                                                                </GridItem3xs10>
                                                                            </>
                                                                        :
                                                                            <GridItem8xs10>
                                                                                <Observacao
                                                                                    values={values}
                                                                                    item={item}
                                                                                    ind={ind}
                                                                                    handleChange={handleChange}
                                                                                />
                                                                            </GridItem8xs10>
                                                                    }

                                                                    <GridItem2>
                                                                        <IconButtonClearEntradaDados
                                                                            onClick={() =>
                                                                                arrayHelpers.remove(ind)
                                                                            }
                                                                            disabled={values.ultimaVersao !== values.versao || ind === 0}
                                                                        />
                                                                    </GridItem2>
                                                                </GridContainer>
                                                            </GridItem12>
                                                        </GridContainer>
                                                    )
                                                })}
                                            </DivForm>
                                        :
                                            <h5>
                                                <br/>
                                                {MESSAGE().orientacaoConfiguracaoFunisEtapas}
                                                <br/>
                                                <br/>
                                            </h5>
                                    }
                                </CardGridDivBodyEntradaDados>
                            </CardGridEntradaDados>
                        )}
                    </FieldArray>
                </GridItem12>
            </GridContainer>
        </ValidatorFormPadrao>
    )
}

export default AcompanhamentoFormFunisEtapas